module.exports = __webpack_public_path__ + "img/Small-Vertical-Rectangular-Attachment-45.d425dd4c.png";